import { TScreenSize } from '../../../../growth-platform-brand-system-v2/src/utils/utils';

export const applyBgColor = (
  color: string,
  inViewport: boolean,
  screenSize: TScreenSize,
) => {
  switch (color) {
    case 'coral':
      return `bg-coral-21 ${
        screenSize === 'xs'
          ? inViewport && 'bg-coral-21'
          : 'group-hover:bg-coral-21 '
      } `;
    case 'azur':
      return `bg-azur-21 ${
        screenSize === 'xs'
          ? inViewport && 'bg-azur-21'
          : 'group-hover:bg-azur-21 '
      } `;
    case 'mint':
      return `bg-mint-21 ${
        screenSize === 'xs'
          ? inViewport && 'bg-mint-21'
          : 'group-hover:bg-mint-21 '
      }`;
    case 'purple':
      return `bg-purple-21 ${
        screenSize === 'xs'
          ? inViewport && 'bg-purple-21'
          : 'group-hover:bg-purple-21 '
      }`;
    case 'yellow':
      return `bg-yellow-21 ${
        screenSize === 'xs'
          ? inViewport && 'bg-yellow-21'
          : 'group-hover:bg-yellow-21 '
      } `;
    default:
      //blue
      return `bg-blue-21 ${
        screenSize === 'xs'
          ? inViewport && 'bg-blue-21'
          : 'group-hover:bg-blue-21 '
      } transition-all duration-500`;
  }
};
